import script from "./ErrorInfo.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20any"
export * from "./ErrorInfo.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20any"

import "./ErrorInfo.vue?vue&type=style&index=0&id=7b02a2b6&lang=css"

const __exports__ = script;

export default __exports__